/* eslint-disable prettier/prettier */
// svga指令
import type SVGA from 'svgaplayerweb'
// interface HTMLDivElementInstance extends HTMLDivElement {
//   __observer?: IntersectionObserver | null
// }

interface SvgaImageType {
  urlORbase64: string
  forKey: string
}
interface SvgaTextType {
  textORMap:
    | string
    | {
        text: string
        size?: string
        family?: string
        color?: string
        offset?: { x: number; y: number }
      }
  forKey: string
}

type Play = (videoItem: SVGA.VideoEntity) => void

// svga缓存池
const svgaCache = new Map<string, SVGA.VideoEntity | null>()
const svgaQueue: Record<string, Array<Play>> = {}
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('svgaDirective', {
    mounted(el, binding) {
      if (binding.value) {
        // 设置canvas不反转
        el.style.direction = 'ltr'
        const player = new window.SVGA.Player(el)
        const parser = new window.SVGA.Parser()
        let svgaUrl: string = ''
        let imageInfo: SvgaImageType[] = []
        let textInfo: SvgaTextType[] = []
        if (typeof binding.value === 'object') {
          svgaUrl = binding.value.url
          imageInfo = binding.value.imageInfo || []
          textInfo = binding.value.textInfo || []
        } else {
          svgaUrl = binding.value
        }

        const observer = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) {
              playSvga()
            } else {
              stopSvga()
            }
          },
          { threshold: 0.1 }
        )
        observer.observe(el)
        el.__observer = observer

        // 播放svga
        const play: Play = (videoItem) => {
          imageInfo.forEach((item) => {
            player.setImage(item.urlORbase64, item.forKey)
          })
          textInfo.forEach((item) => {
            player.setText(item.textORMap, item.forKey)
          })
          player.setVideoItem(videoItem)
          player.startAnimation()
        }

        const playSvga = () => {
          if (svgaCache.has(svgaUrl)) {
            // 缓存池中存在，直接使用缓存池中的数据
            const videoItem = svgaCache.get(svgaUrl)
            if (videoItem) {
              // 缓存池的已加载好，直接播放
              play(videoItem)
            } else {
              // 缓存池的没加载好，添加到队列
              if (svgaQueue[svgaUrl]) {
                svgaQueue[svgaUrl].push(play)
              } else {
                svgaQueue[svgaUrl] = [play]
              }
            }
          } else {
            // 缓存池不存在，开始加载svga
            svgaCache.set(svgaUrl, null) // 先设置为null，防止重复加载
            parser.load(svgaUrl, (videoItem) => {
              play(videoItem)
              svgaCache.set(svgaUrl, videoItem)

              // 加载完之后看下当前加载的svga有没有要处理的队列
              while (svgaQueue[svgaUrl]?.length) {
                const fn = svgaQueue[svgaUrl].pop() as Play
                fn(videoItem)
                // 都处理完了就删除队列的属性
                if (svgaQueue[svgaUrl].length === 0) delete svgaQueue[svgaUrl]
              }
            })
          }
        }

        const stopSvga = () => {
          player.clear()
        }
      }
    },
    unmounted(el) {
      el.__observer?.unobserve(el)
      el.__observer?.disconnect()
      el.__observer = null
    }
  })
})
